<template>
  <b-list-group>
    <b-list-group-item
      v-for="item in log"
      :key="item.ind"
      class="flex-column align-items-start"
      @click="toggle(item.ind)"
    >
      <div
        class="d-flex w-100 justify-content-between"
        style="align-items: center;"
      >
        <h5>
          <span><span
            :title="item.ind"
            class="badge badge-secondary"
            style="margin-right: 10px;"
          >
            {{ item.task.id }}
          </span>{{ item.task.name }}</span>
          <feather-icon
            v-if="item.message !== null"
            class="ml-1"
            style="color: red"
            icon="MessageSquareIcon"
          />
        </h5>
        <b-badge
          class="badge-glow"
          :variant="'light-' + item.processClass"
        >
          {{ item.processText }}
        </b-badge>
      </div>
      <small class="text-secondary">
        <b-badge
          class="badge"
          :variant="'light-dark'"
        >
          START
        </b-badge> {{ dateFormat(item.start) }}
        <b-badge
          v-if="item.end !== null"
          class="badge ml-1"
          :variant="'light-dark'"
        >
          END
        </b-badge> {{ dateFormat(item.end) }}
      </small><br>
      <div
        v-show="records[item.ind] !== undefined && records[item.ind] === true"
        class="w-100 mt-1"
        style="align-items: center; font-size: 12px; font-family: monospace;"
      >

        <div
          v-for="(value, variable) in item.variables"
          v-show="variable !== 'task_type'"
          :key="item.ind +'-' + variable"
          style="margin-bottom:2px"
        >
          <b-badge
            class="badge mr-1"
            :variant="'light-primary'"
          >
            {{ hcv(variable) }} </b-badge>  <small>{{ value }}</small>
        </div>
        <div
          v-if="item.message !== null"
          class="message"
        >
          <b-badge
            class="badge"
            :variant="'light-danger'"
          >
            Message </b-badge> <br>
          <small>{{ item.message }}</small>
        </div>
      </div>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import {
  BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BBadge,
  },
  props: {
    log: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      records: {},
    }
  },
  watch: {
    log(from, to) {
      if (from.length !== to.length) {
        this.initToggle()
      }
    },
  },
  mounted() {
    this.initToggle()
  },
  methods: {
    dateFormat(datetime) {
      if (datetime === null) return ''
      return this.$moment(datetime).format('YYYY/MM/DD HH:mm:ss')
    },
    toggle(index) {
      this.records[index] = !this.records[index]
    },
    initToggle(i = null) {
      this.log.forEach(element => {
        if (this.records[element.ind] === undefined || (i !== null && i !== element.ind)) {
          this.records[element.ind] = false
        }
      })
    },
    hcv(variable) {
      if (variable === 'cores') {
        return 'number_of_cpus'
      }
      return variable
    },
  },
}
</script>
<style>
.list-group-item{
    cursor: pointer;
}
.message{
    background-color: #0000000d;
    padding: 5px;
    margin-top: 6px;
    border-radius: 5px;
    border: 1px solid #00000014;
}
.message .badge{
    margin-bottom: 4px;
}
</style>
